import { getResData, httpClient } from "utils";
import { MaybeNull } from "types";

export const JOBS_API_PATHS = {
  JOBS: (size: number, page: number) => `/jobs?size=${size}&page=${page}`,
};

export interface JobsDTO {
  job: number,
  fileName: string,
  overrideFlag: boolean,
  name: string,
  totalRows: number,
  status: string,
  errors: string[],
  createDate: string,
  updateDate: string,
  type: string,
}

interface JobsPageResultDTO {
  defaultDirection: string,
  defaultSortColumn: MaybeNull<string>,
  direction: MaybeNull<string>,
  page: number,
  size: number,
  sortColumn: MaybeNull<string>,
  totalElements: number,
  totalPages: number,
}

export interface JobsResponseDTO {
  jobs: JobsDTO[],
  pageResult: JobsPageResultDTO,
}

export const getJobs = (size: number, page: number): Promise<JobsResponseDTO> =>
  httpClient.get<JobsResponseDTO>(JOBS_API_PATHS.JOBS(size, page)).then(getResData);